module.exports = __webpack_public_path__ + "static/BDST-Regular-fde8a1922c0b0ab19a27e336f58f6cd5.eot";